import React from 'react'
import classNames from 'classnames'

import './TabSelector.scss'

export interface TabSelectorOption<T extends string | number> {
  key: T
  label: string
}

export interface TabSelectorProps<T extends string | number> {
  selected: T | null
  onClick: (option: T) => void
  options: readonly TabSelectorOption<T>[]
}

function TabSelector<T extends string | number>(props: TabSelectorProps<T>) {
  const { selected, onClick, options } = props

  const refs = options.map(() => React.createRef<HTMLDivElement>())

  // Scroll tab into view if selected programatically. Only run when selected tab changes.
  React.useEffect(() => {
    options.forEach((option, index) => {
      if (selected === option.key) {
        refs[index].current?.scrollIntoView(true)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  return (
    <div className="TabSelector">
      {
        options.map((option, index) => (
          <div
            ref={refs[index]}
            key={option.key}
            onClick={() => onClick(option.key)}
            className={classNames('TabSelector-option', { selected: selected === option.key })}
          >
            {option.label}
          </div>
        ))
      }
    </div>
  )
}

export default TabSelector